export default "__VITE_ASSET__DEKq$5HY__"